<div class="page">
  <div class="content">
    <div class="content-header">
      <div class="title-primary" *ngIf="patientContactType === 'MobilePhone' && newPatient">{{'OneTimeCodeSentToMobileNumberNewPatient' | cpLoginTranslate | async}}: {{patientContactInfo}}</div>
      <div class="title-primary" *ngIf="patientContactType === 'MobilePhone' && !newPatient">{{'OneTimeCodeSentToMobileNumber' | cpLoginTranslate | async}}: {{patientContactInfo}}</div>
      <div class="title-primary" *ngIf="patientContactType === 'Email'">{{'OneTimeCodeSentToEmail' | cpLoginTranslate | async}}: {{patientContactInfo}}</div>
    </div>
    <form class="form-container" [formGroup]="formControls" autocomplete="off" action="">
      <div class="label-wrapper">
        <label>{{'EnterOneTimeCode' | cpLoginTranslate | async}}:</label>
      </div>
      <div class="input-wrapper">
        <input #OneTimeCode autofocus type="text" formControlName="oneTimeCode" autocomplete="off" autocorrect="off" autocapitalize="off" />
        <label *ngIf="isCodeFilled === 'invalid'" class="text-invalid">
          {{'FillOneTimeCode' | cpLoginTranslate | async}}
        </label>
      </div>
      <div class="resend-code-wrapper">
        <label class="resend-code-link" [ngClass]="resendDisabled ? 'disabled' : ''" (click)="resendOneTimeCode()">{{'ResendOneTimeCode' | cpLoginTranslate | async}}</label>
      </div>
      <app-information-box
                  [text1]="notificationBoxText1"
                  [text2]="notificationBoxText2"
                  [icon]="notificationBoxIconType">
      </app-information-box>
    </form>
  </div>
  <div class="buttons-wrapper">
    <cp-button class="primary-button call-to-action" captionToTranslate="Continue.Login.PP" (onClick)="continue()"></cp-button>
  </div>
</div>
